import { IntegrationRecord } from '../types/integrationRecord';
import api from './index';

export const IntegrationAPI = {
  async retrieveIntegrations(companyId: number) {
    const response = await api.get(`/company/${companyId}/integrations`);

    return IntegrationRecord.array().parse(response.data.data);
  },
} as const;
